import type {FinancialDetails, JoinProgress, PaymentFrequency, PaymentMethod, CoverStartDate, HospitalProduct} from '@nib/types-session-api';
import {IWHIJoinState} from '../../store';
import _get from 'lodash/get';

export const selectData = (state: IWHIJoinState): FinancialDetails => _get(state, 'session.session.financialDetails') || ({} as FinancialDetails);

export const selectJoinProgressData = (state: IWHIJoinState): JoinProgress => _get(state, 'session.session.joinProgress') || ({} as JoinProgress);

export const getRate = (state: IWHIJoinState) => selectData(state).rate;

export const getHospitalProduct = (state: IWHIJoinState): HospitalProduct => _get(state, 'session.session.productSelection.hospital') || ({} as HospitalProduct);
export const getExtrasProduct = (state: IWHIJoinState) => _get(state, 'session.session.productSelection.extras') || {};

export const getPaymentFrequency = (state: IWHIJoinState) => selectData(state).paymentFrequency || ('Weekly' as PaymentFrequency);
export const getPaymentMethod = (state: IWHIJoinState) => selectData(state).paymentMethod || ({} as PaymentMethod);
export const getCoverStartDateEntry = (state: IWHIJoinState) => selectData(state).coverStartDate || ({} as CoverStartDate);
export const getHospitalExcess = (state: IWHIJoinState) => getHospitalProduct(state).excess;
export const getHospitalProductId = (state: IWHIJoinState) => getHospitalProduct(state).id;

export const getCoverStartDate = (state: IWHIJoinState) => getCoverStartDateEntry(state).date || '';

export const getFundRulesJoinAgreement = (state: IWHIJoinState) => Boolean(selectJoinProgressData(state).hasAgreedToNibFundRules);
export const getVevoCheckJoinAgreement = (state: IWHIJoinState) => Boolean(selectJoinProgressData(state).hasAgreedToVevoCheck);
